/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Status_InstallingInputs */



/**
* | output |
* | --- |
* | "Being installed" |
*
* @param {Module_Settings_Status_InstallingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_installing = /** @type {((inputs?: Module_Settings_Status_InstallingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_InstallingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Being installed")
	return /** @type {LocalizedString} */ ("En cours d'installation")
});